const route = {
    path: '/',
    meta: { authClass: 'protected' },
    children: [
        {
            path: '',
            components: {
                default:
                    () => import(/* webpackChunkName: "dashboard" */ '../../components/views/dashboard/dashboard.vue'),
            }
        },
    ],
}

module.exports = route;
